// Iconos SVG en línea (sin dependencias). Trazos simples, 24×24, color del texto.
export const ICON_PATHS = {
	map: 'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Zm0 0v14m6-12v14',
	route: 'M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM6 15V9a3 3 0 0 1 3-3h7M18 9v6a3 3 0 0 1-3 3H8',
	leaf: 'M5 19c0-8 6-14 15-14 0 9-6 15-14 15-.4 0-.7 0-1-.1M5 19l7-7',
	image: 'M4 5h16v14H4zM4 15l4-4 4 4 3-3 5 5M15 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
	more: 'M5 12h.01M12 12h.01M19 12h.01',
	tree: 'M12 22v-6m0 0c-4 0-7-2.5-7-6a7 7 0 0 1 14 0c0 3.5-3 6-7 6Z',
	camera: 'M4 8h3l2-3h6l2 3h3v11H4zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
	pin: 'M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11Zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
	back: 'M15 18l-6-6 6-6',
	forward: 'M9 6l6 6-6 6',
	check: 'M5 12l5 5L20 7',
	close: 'M6 6l12 12M18 6 6 18',
	search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9 2-4.1-4.1',
	alert: 'M12 9v4m0 4h.01M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z',
	external: 'M14 4h6v6m0-6-9 9m7 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
	pine: 'M17 14l3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7ZM12 22v-3',
	landmark: 'M3 21h18M5 21v-9m4.7 9v-9m4.6 9v-9M19 21v-9M3 10l9-6 9 6Z',
	mountain: 'm3 20 6-10 4 6 2.5-3.5L21 20Z',
	sparkles:
		'M10 3l1.9 5.1L17 10l-5.1 1.9L10 17l-1.9-5.1L3 10l5.1-1.9ZM18 14l.9 2.1L21 17l-2.1.9L18 20l-.9-2.1L15 17l2.1-.9Z',
	qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM19 14v1M14 19h1M18 18h2v2h-2z',
	flag: 'M5 21V4h12l-2.5 4 2.5 4H5',
	start: 'M8 5.5v13l10.5-6.5Z',
	book: 'M4 19V5a2 2 0 0 1 2-2h14v14H6a2 2 0 0 0-2 2Zm0 0a2 2 0 0 0 2 2h14v-4M8 7h8',
	headphones: 'M4 15v-3a8 8 0 0 1 16 0v3M4 15h3v6H5a1 1 0 0 1-1-1v-5Zm16 0h-3v6h2a1 1 0 0 0 1-1v-5Z',
	list: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
	info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-10v5m0-8h.01',
	globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-9-9h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3',
	lock: 'M6 11h12v10H6zM8 11V7a4 4 0 0 1 8 0v4',
} as const

export type IconName = keyof typeof ICON_PATHS

export const Icon = ({ name, className = 'size-6' }: { name: IconName; className?: string }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		aria-hidden="true"
		data-icon={name}
	>
		<path d={ICON_PATHS[name]} />
	</svg>
)
